import type { QuoteAttributes } from '../../../types/cms'
import { Container, Stack, Box } from '@mui/material'
import { MarkdownText, Text } from 'ui-kit'
import { QuoteContainer } from './styles'

const Quote = ({ author, text, title, backgroundColour }: QuoteAttributes) => {
  return (
    <QuoteContainer
      backgroundColour={backgroundColour}
      height={{ xs: '45rem', sm: '35rem', md: '30rem' }}
    >
      <Container maxWidth={'lg'} sx={{ height: '100%' }}>
        <Stack
          justifyContent={'center'}
          sx={{ height: '100%' }}
          /* Leave room for SlideCarousel dots so author isn't level with them */
          pt={10}
          pb={10}
        >
          <MarkdownText>{title}</MarkdownText>
          <Stack
            justifyContent={'center'}
            alignItems={'flex-start'}
            direction={'row'}
            sx={{ height: '100%' }}
            gap={1.5}
            pt={'2rem'}
          >
            <Box display={{ xs: 'none', md: 'block' }}>
              <img
                src="/graphic_quote_symbol.svg"
                width={68}
                height={55}
                alt="quote"
              />
            </Box>
            <Stack gap={2} pt={{ md: '2.25rem' }} sx={{ maxWidth: '100%' }}>
              <Text variant="p" component="p" className="quote-text">
                {text}
              </Text>
              <Text variant="p" component="p" className="quote-author">
                {author}
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </QuoteContainer>
  )
}

export default Quote
